var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"about-scene",class:{ 'about-scene--visible': _vm.isModelLoaded, 'about-scene--mobile': _vm.isMobile }},[_c('canvas',{ref:"scene__container",staticClass:"about-scene__container"})])}
var staticRenderFns = []

export { render, staticRenderFns }